import styled from "styled-components/macro";

import type { ThemeProps as Props } from "models/styles/theme";

import { Modal } from "components/Modal";
import { CssFlex } from "styles/helpers/layout";

export const StyledModal = styled(Modal)`
  width: 50rem;
  max-width: 100%;
  border-radius: 1rem;
`;

export const StyledDetailsBox = styled(CssFlex)<Props>`
  padding: 1rem;
  border-radius: 0.5rem;
  background-color: ${(props: Props) => props.theme.palette.neutral._999};

  ul {
    margin: 0;
    padding: 0;
    list-style: none;

    display: flex;
    flex-direction: column;
    gap: 1rem;

    li {
      display: flex;
      gap: 1rem;
      align-items: center;
      justify-content: space-between;
    }
  }
`;
